import React from 'react';
import { FormattedMessage } from 'react-intl';

const StatoFumo = ({ stat }) => {
    return (
        <>
            <div className="rack">
                <div className="w20">
                    <p><i className="fa fa-circle" style={{ color: stat.supervisione_led ? "red" : "rgb(176, 176, 176)" }} />
                        <FormattedMessage id="App.info.Supervisione" /></p>
                </div>
                <div className="w20">
                    <p><i className="fa fa-circle" style={{ color: stat.fumo ? "red" : "rgb(176, 176, 176)" }} />
                        <FormattedMessage id="App.info.Fumo" /></p>
                </div>
            </div>
            <div className="rack">
                <div className="w20">
                    <p><i className="fa fa-circle" style={{ color: stat.batteria_scarica ? "red" : (stat.batteria_scarica === false ? "#ffc20a" : "rgb(176, 176, 176)") }} />
                        <FormattedMessage id="App.info.BatteriaScarica" /></p>
                </div>
                <div className="w20">
                    <p><i className="fa fa-circle" style={{ color: stat.dormiente ? "red" : "rgb(176, 176, 176)" }} />
                        <FormattedMessage id="App.info.Dormiente" /></p>
                </div>
                <div className="w20">
                    <p><i className="fa fa-circle" style={{ color: stat.guasto ? "red" : "rgb(176, 176, 176)" }} />
                        <FormattedMessage id="App.info.Guasto" /></p>
                </div>
            </div>
        </>
    );
};

export default StatoFumo;